<template>
  <div title="Menü" class="wrapper" v-if="updateSide">
    <router-link to="/assistenzhunde"><img title="Assistenzhunde" src="/img/aside/aside1.png"></router-link>
    <router-link to="/story-atelier"><img title="Story Atelier" src="/img/aside/aside3.png"></router-link>
    <router-link to="/ausstellung"><img title="Ausstellung Barrierefrei" src="/img/aside/aside2.png"></router-link>
  </div>
  <div title="Menü" v-bind:class="'wrapper'" v-else>
    <router-link to="/assistenzhunde"><img title="Assistenzhunde" src="/img/aside/small1.png"></router-link>
    <router-link to="/story-atelier"><img title="Story Atelier" src="/img/aside/small2.png"></router-link>
    <router-link to="/ausstellung"><img title="Ausstellung Barrierefrei" src="/img/aside/small3.png"></router-link>
  </div>
</template>

<style scoped>
.wrapper {
  height:100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

img{
  width:120px;
  margin-bottom:-4px;
  flex-grow: 1;
}

@media (orientation: landscape) and (max-width:981px){
.swiper-button-white{
  display:none;
}

.displayNone{
  display:none;
}
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
img{
  width:75px;
  margin-bottom:-4px;
  flex-grow: 1;
}

}

@media (orientation: landscape) and (min-height:768px) {
  .wrapper {
    height:100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  img{
    width:120px;
  }
}

@media (orientation: landscape) and (max-height: 414px) {
  img{
    width:75px;
  }
}
@media (orientation: portrait) and (max-width: 968px){

.wrapper {
  height:100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top:0px;
}

img{
  width:75px;
  margin-bottom:-4px;
  flex-grow: 1;
}

}

</style>

<script>
export default {
  name: 'Side',
  data () {
    return {
      responsive: true
    }
  },
  computed: {
    updateSide () {
      return this.responsive
    },
    showSubMenu () {
      return this.$store.state.showSubMenu
    }
  },
  methods: {
    changeSide () {
      if (window.innerWidth < 800) {
        this.responsive = false
      } else {
        this.responsive = true
      }
      if (window.innerWidth < 900 && window.innerHeight < 500) {
        this.responsive = false
      }
    }
  },
  mounted () {
    this.changeSide()
    window.addEventListener('resize', this.changeSide)
  }
}
</script>
